import { Button, ButtonProps, Icon, Text } from '@chakra-ui/react'
import React from 'react'
import { IconType } from 'react-icons'
import { MdPhoneInTalk, MdDelete, MdAdd } from 'react-icons/md'
import { p2r } from '../../utils/font'

// 基本ボタンのプロパティ
type BaseVideoButtonProps = {
  icon?: IconType
  children: React.ReactNode
  isMobile?: boolean
} & ButtonProps

// 入室ボタン
export const EnterRoomButton: React.FC<BaseVideoButtonProps> = ({
  icon = MdPhoneInTalk,
  children,
  isMobile = false,
  ...rest
}) => (
  <Button
    px={isMobile ? '16px' : '8px'}
    py="12px"
    variant="outline"
    borderRadius="80px"
    backgroundColor="#6AA43B"
    borderWidth="0"
    display="flex"
    columnGap="10px"
    w={isMobile ? 'fit-content' : p2r(148)}
    h={isMobile ? p2r(40) : p2r(48)}
    _hover={{
      backgroundColor: "#6AA43B",
    }}
    _disabled={{
      backgroundColor: "#D1D5DB",
      cursor: "not-allowed",
      opacity: 1,
      _hover: {
        backgroundColor: "#D1D5DB",
      },
    }}
    {...rest}
  >
    <Icon
      as={icon}
      boxSize={isMobile ? p2r(20) : p2r(24)}
      color="text.white"
    />
    <Text
      fontSize={p2r(16)}
      color="#FFFDFC"
      fontWeight="700"
      fontFamily="'BIZ UDPGothic', sans-serif"
    >
      {children}
    </Text>
  </Button>
)

// キャンセル/削除ボタン
export const CancelButton: React.FC<BaseVideoButtonProps> = ({
  icon = MdDelete,
  children,
  isMobile = false,
  ...rest
}) => (
  <Button
    leftIcon={<Icon as={icon} />}
    size={isMobile ? "sm" : "md"}
    borderRadius="80px"
    variant="outline"
    borderWidth="2px"
    borderColor="#C84545"
    px={isMobile ? '16px' : '24px'}
    h={isMobile ? p2r(40) : p2r(48)}
    fontFamily="'BIZ UDPGothic', sans-serif"
    color="#C84545"
    backgroundColor="transparent"
    _hover={{
      backgroundColor: "transparent",
      borderColor: "#C84545",
      color: "#C84545",
    }}
    {...rest}
  >
    {children}
  </Button>
)

// 予約作成ボタン
export const CreateReservationButton: React.FC<BaseVideoButtonProps> = ({
  icon = MdAdd,
  children,
  ...rest
}) => (
  <Button
    leftIcon={<Icon as={icon} />}
    size="md"
    borderRadius="80px"
    backgroundColor="#6AA43B"
    px="24px"
    py="12px"
    fontFamily="'BIZ UDPGothic', sans-serif"
    color="white"
    _hover={{
      backgroundColor: "#6AA43B",
    }}
    {...rest}
  >
    {children}
  </Button>
)

// 汎用的なVideoButtonも含める（既存のVideoButtonコンポーネント）
export type VideoButtonProps = {
  icon: React.FC
  onClick(): void
  children: React.ReactNode
} & ButtonProps

export const VideoButton: React.FC<VideoButtonProps> = ({
  icon,
  onClick,
  children,
  ...rest
}) => (
  <Button
    h="fit-content"
    px="24px"
    py="4px"
    leftIcon={<Icon as={icon} boxSize="32px" color="grand.grayDark" />}
    color="text.headline"
    fontWeight="700"
    fontSize={p2r(16)}
    variant="outline"
    backgroundColor="grand.white"
    borderColor="theme.primary"
    borderRadius="30px"
    onClick={onClick}
    _hover={{
      backgroundColor: "grand.white",
      borderColor: "theme.primary",
    }}
    {...rest}
  >
    {children}
  </Button>
) 